import { create } from 'zustand'

export const showMenuStore = create((set) => ({
  showMenu: false,
  setShowMenu: (value) => set({ showMenu: value })
}))
